import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from "@/store";
import { clearAuthSession, getAuthToken } from "@/utils/auth";

const TOKEN_HEADER = 'X-Wanyoo-Token'

// export const baseUrl = 'http://114.117.203.137:8081'
// export const baseUrl = 'http://139.186.149.117:8081'

export const baseUrl = window.location.origin+'/proxy/'
// export const baseUrl = 'http://162.14.123.184:8081'
// export const baseUrl = 'https://sidequesthub.com/proxy/'

//创建axios实例
const request = axios.create({
    baseURL: baseUrl,
    // baseURL: window.location.origin+'/proxy/',
    timeout: 10000,
})

//请求拦截
request.interceptors.request.use((config:any)=>{
    const token = getAuthToken()
    config.__authToken = token

    if(token){
        if(typeof config.headers?.set === 'function'){
            config.headers.set(TOKEN_HEADER, token)
        }else {
            config.headers = {
                ...config.headers,
                [TOKEN_HEADER]: token
            }
        }
    }else if(typeof config.headers?.delete === 'function'){
        config.headers.delete(TOKEN_HEADER)
    }else if(config.headers){
        delete config.headers[TOKEN_HEADER]
    }
    return config
},err=>{
    return Promise.reject(err)
})

const retryWithLatestToken = (res:any) => {
    const currentToken = getAuthToken()
    const requestToken = res.config?.__authToken

    // 登录前或旧登录态发出的请求，不允许用迟到的 401/402 清除新 token。
    if(currentToken && currentToken !== requestToken && !res.config?.__authRetried){
        res.config.__authRetried = true
        return request(res.config)
    }

    return null
}

const handleAuthFailure = (msg:string) => {
    clearAuthSession()
    if(location.href.indexOf('/h5') > -1){
        ElMessage({
            type:'error',
            message:msg,
        })
    }else if(!(store.state as any).http.loginState) {
        store.dispatch('http/setLoginState',true)
    }
}

//响应拦截
request.interceptors.response.use((res:any)=>{
    if(res.data.code === 200) return  res
    else if(res.data.code === 401){
        const retry = retryWithLatestToken(res)
        if(retry) return retry
        handleAuthFailure(res.data.msg)
    }
    else if(res.data.code === 402){
        const retry = retryWithLatestToken(res)
        if(retry) return retry
        clearAuthSession()
        if(location.href.indexOf('/h5') == -1){
            window.location.href = res.data.url
        }
    } else if(res.data.code !== 200 && location.href.indexOf('/h5') > -1) {
        ElMessage({
            type:'error',
            message:res.data.msg
        })

        return Promise.reject(res)
    }else {
        store.dispatch('http/setHttpState',{
            state:false,
            dialogVisible:true,
            msg:res.data.msg
        })
    }
    return Promise.reject(res)
},err=>{
    return Promise.reject(err)
})


/**
 * 用于发送请求的通用方法
 * @param {*} data 配置信息，method请求方法，params参数，path路由
 * @returns
 */
async function http(data:any){
    let result
    if(data.method === 'get' || data.method === 'delete'){
        await request({
            url: data.path,
            method: data.method,
            params:data.params
        }).then(res=>{
            result = res.data.data?res.data.data:res.data
        })
            .catch(() => {
                console.log('err')
            })
    }else if(data.method === 'post' || data.method === 'put' || data.method === 'patch'){
        await request({
            url: data.path,
            method: data.method,
            data:data.params
        }).then(res=>{
            result = res.data.data?res.data.data:res.data
        })
            .catch(() => {
                console.log('err')
            })
    }

    return result

}

export default http
